import { App, getServerSideProps } from 'user-profile'

const Profile = (props) => {
  return <App {...props} />
}

export { getServerSideProps }
export default Profile
